<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-form :model="queryCondition" :label-position="labelPosition" label-width="100px">
                    <el-row :gutter="16" class="form-row">
                        <el-col :span="8">
                            <el-form-item label="料架类型编号">
                                <el-input class="handle-input" v-model="queryCondition.mateNo" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架类型名称">
                                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="query-btn-row">
                        <el-col>
                            <el-button type="primary">搜索</el-button>
                            <el-button type="primary">重置</el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="form-row">
                        <el-col :span="8">
                            <el-form-item label="BCM号">
                                <el-input class="handle-input" v-model="queryCondition.bcm" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="材质">
                                <el-select v-model="queryCondition.material" class="handle-input">
                                    <el-option key="1" label="铁" value="铁"></el-option>
                                    <el-option key="2" label="塑料" value="塑料"></el-option>
                                    <el-option key="3" label="铁+塑料" value="铁+塑料"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="action-btn-row">
                <el-button class="btn" type="primary" @click="addOrEditMaterial">新增</el-button>
                <el-button class="btn" type="primary" @click="uploadTemplate">上传</el-button>
                <el-button class="btn" type="primary" @click="downloadTemplate">下载</el-button>
            </el-row>
            <el-table :data="tableData" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip label="料架类型编号">
                    <template slot-scope="scope">
                        <router-link class="a-link" replace :to="{name: 'material-rack-edit', params:{no: scope.row.no}}">{{scope.row.no}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="料架类型名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="bcm" label="BCM号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="color" label="颜色"></el-table-column>
                <el-table-column show-overflow-tooltip prop="packageName" label="包装类型名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="material" label="材质"></el-table-column>
                <el-table-column show-overflow-tooltip prop="total" label="装载量"></el-table-column>
                <el-table-column show-overflow-tooltip prop="attachment" label="附件"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="更新日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateUser" label="更新人"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'material-rack',
        data() {
            return {
                tableData: [{
                    no: 'VB-1967434343',
                    name: '123456',
                    bcm: '00000000',
                    color: 'red',
                    packageName: '24232',
                    material: '666',
                    total: 77,
                    attachment: '888',
                    updateTime: '2019-09-09',
                    updateUser: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                queryCondition:{
                    mateNo: '',
                    mateName: '',
                    bcm: '',
                    material: ''
                }
            }
        },
        methods: {
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            /**
             * 新增料架
             */
            addOrEditMaterial(){
                this.$router.replace({
                    name: 'material-rack-edit'
                });
            },
            /**
             * 上传excel
             */
            uploadTemplate(){

            },
            /**
             * 下载excel
             */
            downloadTemplate(){

            }
        }
    }
</script>
<style scoped>
    .handle-input{
        width: 95%;
    }
    /*.form-row{
        text-align: right;
    }*/
    .query-btn-row{
        width:30%;
        float: right;
    }
    .action-btn-row{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .a-link{
        text-decoration: underline;
    }
</style>